import React, { useMemo } from 'react';

import { IonButtons, IonIcon, IonTitle, IonToolbar } from '@ionic/react';
import { chevronBackOutline, chevronForwardOutline } from 'ionicons/icons';

import { useNumberFormat } from 'intl';

import './index.css';

export default ({
  count,
  limit,
  offset,
  onChange,
}: {
  count: number;
  limit: number;
  offset: number;
  onChange: (event: any, value: { limit: number; offset: number }) => void;
}) => {
  const numberFormat = useNumberFormat();
  const totalPages = useMemo(() => {
    return numberFormat(Math.ceil(count / limit));
  }, [numberFormat, count, limit]);

  const currentPage = useMemo(() => {
    return numberFormat(Math.ceil(offset / limit) + 1);
  }, [numberFormat, offset, limit]);

  const total = useMemo(() => {
    return numberFormat(count);
  }, [numberFormat, count]);

  const handleBack = (event: any) => {
    const nextOffset = offset - limit;
    onChange(event, { limit, offset: nextOffset });
  };

  const handleForward = (event: any) => {
    const nextOffset = offset + limit;
    onChange(event, { limit, offset: nextOffset });
  };

  const isDisableBack = useMemo(() => {
    return offset - limit < 0;
  }, [offset, limit]);

  const isDisableForward = useMemo(() => {
    return offset + limit > count;
  }, [offset, limit, count]);

  return (
    <IonToolbar className={'datatable-pagination'}>
      <IonButtons slot={'start'}>{total} records</IonButtons>
      <IonTitle>
        {currentPage} page of {totalPages}
      </IonTitle>
      <IonButtons slot={'end'}>
        <IonIcon
          icon={chevronBackOutline}
          onClick={handleBack}
          className={
            isDisableBack ? 'datatable-pagination-disabled' : undefined
          }
        />
        <IonIcon
          icon={chevronForwardOutline}
          onClick={handleForward}
          className={
            isDisableForward ? 'datatable-pagination-disabled' : undefined
          }
        />
      </IonButtons>
    </IonToolbar>
  );
};
